/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string; }
};

export type AdditionalAnalyticsValueType = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAddress_1FilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAddress_2FilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCaregiverFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type AddressCityFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCountryCodeFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateMutation = {
  address: Maybe<AddressNode>;
};

export type AddressFilterInputType = {
  /** `Address_1` field */
  address1?: InputMaybe<AddressAddress_1FilterInputType>;
  /** `Address_2` field */
  address2?: InputMaybe<AddressAddress_2FilterInputType>;
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<AddressFilterInputType>>>;
  /** `Caregiver` field */
  caregiver?: InputMaybe<AddressCaregiverFilterInputType>;
  /** `City` field */
  city?: InputMaybe<AddressCityFilterInputType>;
  /** `CountryCode` field */
  countryCode?: InputMaybe<AddressCountryCodeFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<AddressFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<AddressFilterInputType>>>;
  /** `ProvinceCode` field */
  provinceCode?: InputMaybe<AddressProvinceCodeFilterInputType>;
  /** `Zipcode` field */
  zipcode?: InputMaybe<AddressZipcodeFilterInputType>;
};

export type AddressNode = Node & {
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  caregiver: Maybe<CaregiverNode>;
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  provinceCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zipcode: Scalars['String']['output'];
};

export type AddressNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AddressNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AddressNode` and its cursor. */
export type AddressNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<AddressNode>;
};

export type AddressProvinceCodeFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateMutation = {
  address: Maybe<AddressNode>;
};

export type AddressZipcodeFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type BillingEligibilityCheckCompletedByFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type BillingEligibilityCheckCreateMutation = {
  billingEligibilityCheck: Maybe<BillingEligibilityCheckNode>;
};

export type BillingEligibilityCheckFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<BillingEligibilityCheckFilterInputType>>>;
  /** `CompletedBy` field */
  completedBy?: InputMaybe<BillingEligibilityCheckCompletedByFilterInputType>;
  /** `IsEligible` field */
  isEligible?: InputMaybe<BillingEligibilityCheckIsEligibleFilterInputType>;
  /** `Member` field */
  member?: InputMaybe<BillingEligibilityCheckMemberFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<BillingEligibilityCheckFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<BillingEligibilityCheckFilterInputType>>>;
};

export type BillingEligibilityCheckIsEligibleFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingEligibilityCheckMemberFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type BillingEligibilityCheckNode = Node & {
  completedBy: Maybe<UserNode>;
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  member: Maybe<MemberNode>;
  memberstatuslookup: Maybe<MemberStatusLookupNode>;
  note: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BillingEligibilityCheckNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingEligibilityCheckNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BillingEligibilityCheckNode` and its cursor. */
export type BillingEligibilityCheckNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BillingEligibilityCheckNode>;
};

export type BillingEligibilityCheckUpdateMutation = {
  billingEligibilityCheck: Maybe<BillingEligibilityCheckNode>;
};

export type BillingProfileExternalMemberIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type BillingProfileFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<BillingProfileFilterInputType>>>;
  /** `ExternalMemberId` field */
  externalMemberId?: InputMaybe<BillingProfileExternalMemberIdFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<BillingProfileFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<BillingProfileFilterInputType>>>;
};

export type BillingProfileNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The identification number of the Member in their insurance provider's system. */
  externalMemberId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  insuranceProvider: Maybe<InsuranceProviderNode>;
  /** @deprecated Use .insuranceProvider.mcsPartner.slug instead. */
  mcsPartnerName: Scalars['String']['output'];
  member: Maybe<MemberNode>;
  phiFileReferences: PhiFileReferenceNodeConnection;
  policyHolder: Maybe<PolicyHolderNode>;
  updatedAt: Scalars['DateTime']['output'];
};


export type BillingProfileNodePhiFileReferencesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  s3BucketName: InputMaybe<Scalars['String']['input']>;
  s3Key: InputMaybe<Scalars['String']['input']>;
};

export type BillingProfileNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingProfileNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BillingProfileNode` and its cursor. */
export type BillingProfileNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BillingProfileNode>;
};

export type BillingProfileUpdateMutation = {
  billingProfile: Maybe<BillingProfileNode>;
};

export type CaregiverCaregivermightiermetadataExternalUserIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverCaregivermightiermetadataFilterInputType = {
  /** `ExternalUserId` subfield */
  externalUserId?: InputMaybe<CaregiverCaregivermightiermetadataExternalUserIdFilterInputType>;
  /** `ShopifyCustomerId` subfield */
  shopifyCustomerId?: InputMaybe<CaregiverCaregivermightiermetadataShopifyCustomerIdFilterInputType>;
};

export type CaregiverCaregivermightiermetadataShopifyCustomerIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverCreateShopifyOrderMutation = {
  shopifyOrder: Maybe<ShopifyOrderType>;
};

export type CaregiverEmailFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Iexact` lookup */
  iexact?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<CaregiverFilterInputType>>>;
  /** `Caregivermightiermetadata` field */
  caregivermightiermetadata?: InputMaybe<CaregiverCaregivermightiermetadataFilterInputType>;
  /** `Email` field */
  email?: InputMaybe<CaregiverEmailFilterInputType>;
  /** `FirstName` field */
  firstName?: InputMaybe<CaregiverFirstNameFilterInputType>;
  /** `LastName` field */
  lastName?: InputMaybe<CaregiverLastNameFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<CaregiverFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<CaregiverFilterInputType>>>;
  /** `PhoneNumber` field */
  phoneNumber?: InputMaybe<CaregiverPhoneNumberFilterInputType>;
};

export type CaregiverFirstNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverLastNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverMightierMetadataNode = Node & {
  caregiver: Maybe<CaregiverNode>;
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  externalUserId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  shopifyCustomerId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CaregiverNode = Node & {
  addressSet: AddressNodeConnection;
  caregivermightiermetadata: Maybe<CaregiverMightierMetadataNode>;
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  locale: McsCaregiverLocaleChoices;
  memberSet: MemberNodeConnection;
  optedInMarketingEmail: Scalars['Boolean']['output'];
  optedInSms: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CaregiverNodeAddressSetArgs = {
  address1: InputMaybe<Scalars['String']['input']>;
  address2: InputMaybe<Scalars['String']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  caregiver: InputMaybe<Scalars['ID']['input']>;
  city: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  provinceCode: InputMaybe<Scalars['String']['input']>;
  zipcode: InputMaybe<Scalars['String']['input']>;
};


export type CaregiverNodeMemberSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  billingprofile_ExternalMemberId: InputMaybe<Scalars['String']['input']>;
  billingprofile_InsuranceProvider_Slug: InputMaybe<Scalars['String']['input']>;
  caregiver_Email: InputMaybe<Scalars['String']['input']>;
  caregiver_Email_Icontains: InputMaybe<Scalars['String']['input']>;
  caregiver_Email_Iexact: InputMaybe<Scalars['String']['input']>;
  caregiver_Email_Startswith: InputMaybe<Scalars['String']['input']>;
  caregiver_FirstName: InputMaybe<Scalars['String']['input']>;
  caregiver_FirstName_Icontains: InputMaybe<Scalars['String']['input']>;
  caregiver_LastName: InputMaybe<Scalars['String']['input']>;
  caregiver_LastName_Icontains: InputMaybe<Scalars['String']['input']>;
  caregiver_PhoneNumber: InputMaybe<Scalars['String']['input']>;
  caregiver_PhoneNumber_Startswith: InputMaybe<Scalars['String']['input']>;
  clinician_Email: InputMaybe<Scalars['String']['input']>;
  clinician_Email_Startswith: InputMaybe<Scalars['String']['input']>;
  clinician_FirstName: InputMaybe<Scalars['String']['input']>;
  clinician_FirstName_Icontains: InputMaybe<Scalars['String']['input']>;
  clinician_Id: InputMaybe<Scalars['ID']['input']>;
  clinician_LastName: InputMaybe<Scalars['String']['input']>;
  clinician_LastName_Icontains: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: InputMaybe<Scalars['Date']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  firstName_Icontains: InputMaybe<Scalars['String']['input']>;
  isHidden: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  lastName_Icontains: InputMaybe<Scalars['String']['input']>;
  memberSubscriptionOrderCount: InputMaybe<Scalars['Decimal']['input']>;
  membermightiermetadata_ExternalAccountId: InputMaybe<Scalars['String']['input']>;
  membermightiermetadata_ExternalPlayerId: InputMaybe<Scalars['String']['input']>;
  membermightiermetadata_Isnull: InputMaybe<Scalars['Boolean']['input']>;
  memberstatuslookup_LatestBillingEligibilityCheck_IsEligible: InputMaybe<Scalars['Boolean']['input']>;
  memberstatuslookup_LatestBillingEligibilityCheck_Isnull: InputMaybe<Scalars['Boolean']['input']>;
  memberstatuslookup_LatestClinicalEligibilityCheck_IsEligible: InputMaybe<Scalars['Boolean']['input']>;
  memberstatuslookup_LatestClinicalEligibilityCheck_Isnull: InputMaybe<Scalars['Boolean']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  reviewhold_IsOpen: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaregiverNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CaregiverNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CaregiverNode` and its cursor. */
export type CaregiverNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CaregiverNode>;
};

export type CaregiverPhoneNumberFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverUpdateMutation = {
  caregiver: Maybe<CaregiverNode>;
};

export type ClinicalEligibilityCheckCompletedByFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type ClinicalEligibilityCheckCreateMutation = {
  clinicalEligibilityCheck: Maybe<ClinicalEligibilityCheckNode>;
};

export type ClinicalEligibilityCheckFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<ClinicalEligibilityCheckFilterInputType>>>;
  /** `CompletedBy` field */
  completedBy?: InputMaybe<ClinicalEligibilityCheckCompletedByFilterInputType>;
  /** `IsEligible` field */
  isEligible?: InputMaybe<ClinicalEligibilityCheckIsEligibleFilterInputType>;
  /** `Member` field */
  member?: InputMaybe<ClinicalEligibilityCheckMemberFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<ClinicalEligibilityCheckFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<ClinicalEligibilityCheckFilterInputType>>>;
};

export type ClinicalEligibilityCheckIsEligibleFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicalEligibilityCheckMemberFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type ClinicalEligibilityCheckNode = Node & {
  completedBy: Maybe<UserNode>;
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  member: Maybe<MemberNode>;
  memberstatuslookup: Maybe<MemberStatusLookupNode>;
  note: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClinicalEligibilityCheckNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClinicalEligibilityCheckNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ClinicalEligibilityCheckNode` and its cursor. */
export type ClinicalEligibilityCheckNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClinicalEligibilityCheckNode>;
};

export type ClinicalEligibilityCheckUpdateMutation = {
  clinicalEligibilityCheck: Maybe<ClinicalEligibilityCheckNode>;
};

export type ConsentToTreatInputType = {
  disclosureFileName: Scalars['String']['input'];
  disclosureMd5: Scalars['String']['input'];
  methodOfSignature: Scalars['String']['input'];
  signatureRecordedAt: Scalars['DateTime']['input'];
};

export type CreateAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  caregiver: Scalars['ID']['input'];
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  isCurrent: Scalars['Boolean']['input'];
  provinceCode: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CreateBillingEligibilityCheckInput = {
  isEligible: Scalars['Boolean']['input'];
  member: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClinicalEligibilityCheckInput = {
  isEligible: Scalars['Boolean']['input'];
  member: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDataReviewCheckInput = {
  member: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExternalOrderProviderInput = {
  niceName?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateMemberSubscriptionOrderInput = {
  externalId: Scalars['String']['input'];
  externalOrderProvider: Scalars['ID']['input'];
  member: Scalars['ID']['input'];
};

export type CreatePhiFileReferenceInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Files may be uploaded during intake, but may never be associated with a member, for example if intake was never completed. We must store some info so that any orphaned records may be identified. */
  identifyingInfo: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
};

export type CreateReviewHoldInput = {
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  member: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type DataReviewCheckCompletedByFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type DataReviewCheckCreateMutation = {
  dataReviewCheck: Maybe<DataReviewCheckNode>;
};

export type DataReviewCheckFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<DataReviewCheckFilterInputType>>>;
  /** `CompletedBy` field */
  completedBy?: InputMaybe<DataReviewCheckCompletedByFilterInputType>;
  /** `Member` field */
  member?: InputMaybe<DataReviewCheckMemberFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<DataReviewCheckFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<DataReviewCheckFilterInputType>>>;
};

export type DataReviewCheckMemberFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type DataReviewCheckNode = Node & {
  completedBy: Maybe<UserNode>;
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  member: Maybe<MemberNode>;
  memberstatuslookup: Maybe<MemberStatusLookupNode>;
  note: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DataReviewCheckNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DataReviewCheckNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DataReviewCheckNode` and its cursor. */
export type DataReviewCheckNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<DataReviewCheckNode>;
};

export type DataReviewCheckUpdateMutation = {
  dataReviewCheck: Maybe<DataReviewCheckNode>;
};

export type ExternalOrderProviderCreateMutation = {
  externalOrderProvider: Maybe<ExternalOrderProviderNode>;
};

export type ExternalOrderProviderFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<ExternalOrderProviderFilterInputType>>>;
  /** `Not` field */
  not?: InputMaybe<ExternalOrderProviderFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<ExternalOrderProviderFilterInputType>>>;
  /** `Slug` field */
  slug?: InputMaybe<ExternalOrderProviderSlugFilterInputType>;
};

export type ExternalOrderProviderNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  membersubscriptionorderSet: MemberSubscriptionOrderNodeConnection;
  niceName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ExternalOrderProviderNodeMembersubscriptionorderSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  externalId: InputMaybe<Scalars['String']['input']>;
  externalOrderProviderId: InputMaybe<Scalars['ID']['input']>;
  externalOrderProvider_Slug: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  memberId: InputMaybe<Scalars['ID']['input']>;
  member_Caregiver_Email_Iexact: InputMaybe<Scalars['String']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalOrderProviderNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExternalOrderProviderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ExternalOrderProviderNode` and its cursor. */
export type ExternalOrderProviderNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ExternalOrderProviderNode>;
};

export type ExternalOrderProviderSlugFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Iexact` lookup */
  iexact?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceProviderFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<InsuranceProviderFilterInputType>>>;
  /** `McsPartner` field */
  mcsPartner?: InputMaybe<InsuranceProviderMcsPartnerFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<InsuranceProviderFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<InsuranceProviderFilterInputType>>>;
  /** `Slug` field */
  slug?: InputMaybe<InsuranceProviderSlugFilterInputType>;
};

export type InsuranceProviderMcsPartnerFilterInputType = {
  /** `Slug` subfield */
  slug?: InputMaybe<InsuranceProviderMcsPartnerSlugFilterInputType>;
};

export type InsuranceProviderMcsPartnerSlugFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceProviderNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  mcsPartner: Maybe<McsPartnerNode>;
  niceName: Scalars['String']['output'];
  /** A constantized unique ID - can use for things like i18n, etc. */
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InsuranceProviderNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InsuranceProviderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InsuranceProviderNode` and its cursor. */
export type InsuranceProviderNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InsuranceProviderNode>;
};

export type InsuranceProviderSlugFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type IntakeSubmitAddressInputType = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  isCurrent: Scalars['Boolean']['input'];
  provinceCode: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type IntakeSubmitBillingProfileInputType = {
  externalMemberId: Scalars['String']['input'];
  insuranceProvider?: InputMaybe<Scalars['ID']['input']>;
  /** The IDs and claim codesof any PhiFileReference objects that were uploaded during intake. The PhiFileReference objectsmust have have `policy_holder_id` column set to `null`, so the column can be set to the ID of the `PolicyHolder` object that is created. */
  phiFileReferencesToClaim?: InputMaybe<Array<InputMaybe<PhiFileReferenceClaimType>>>;
  policyHolder?: InputMaybe<IntakeSubmitPolicyHolderInputType>;
};

export type IntakeSubmitCaregiverInputType = {
  addressAdd: IntakeSubmitAddressInputType;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  optedInMarketingEmail: Scalars['Boolean']['input'];
  optedInSms: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type IntakeSubmitInputType = {
  additionalAnalyticsValues?: InputMaybe<Array<InputMaybe<AdditionalAnalyticsValueType>>>;
  member: IntakeSubmitMemberInputType;
};

export type IntakeSubmitMemberInputType = {
  billingProfile: IntakeSubmitBillingProfileInputType;
  caregiver: IntakeSubmitCaregiverInputType;
  caregiverRelationshipToMember: Scalars['String']['input'];
  consentToTreat: ConsentToTreatInputType;
  dateOfBirth: Scalars['Date']['input'];
  ethnicity: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  isHomeInternetReliable: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  race: Scalars['String']['input'];
};

export type IntakeSubmitMutation = {
  graphqlMemberId: Maybe<Scalars['ID']['output']>;
};

export type IntakeSubmitPolicyHolderInputType = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  externalSubscriberNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum McsCaregiverLocaleChoices {
  /** Arabic - ar */
  Ar = 'AR',
  /** English - en */
  En = 'EN',
  /** Spanish - es */
  Es = 'ES',
  /** French (Canadian) - fr-CA */
  FrCa = 'FR_CA',
  /** Hmong - hmn */
  Hmn = 'HMN',
  /** Russian - ru */
  Ru = 'RU',
  /** Somali - so */
  So = 'SO',
  /** Ukrainian - uk */
  Uk = 'UK',
  /** Vietnamese - vi */
  Vi = 'VI',
  /** Simplified Chinese - zh-CN */
  ZhCn = 'ZH_CN'
}

export type McsPartnerNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  insuranceproviderSet: InsuranceProviderNodeConnection;
  niceName: Scalars['String']['output'];
  /** A constantized unique ID - can use for things like i18n, etc. */
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type McsPartnerNodeInsuranceproviderSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  mcsPartner_Slug: InputMaybe<Scalars['String']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type MemberBillingprofileExternalMemberIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type MemberBillingprofileFilterInputType = {
  /** `ExternalMemberId` subfield */
  externalMemberId?: InputMaybe<MemberBillingprofileExternalMemberIdFilterInputType>;
  /** `InsuranceProvider` subfield */
  insuranceProvider?: InputMaybe<MemberBillingprofileInsuranceProviderFilterInputType>;
};

export type MemberBillingprofileInsuranceProviderFilterInputType = {
  /** `Slug` subfield */
  slug?: InputMaybe<MemberBillingprofileInsuranceProviderSlugFilterInputType>;
};

export type MemberBillingprofileInsuranceProviderSlugFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type MemberCaregiverEmailFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Icontains` lookup */
  icontains?: InputMaybe<Scalars['String']['input']>;
  /** `Iexact` lookup */
  iexact?: InputMaybe<Scalars['String']['input']>;
  /** `Startswith` lookup */
  startswith?: InputMaybe<Scalars['String']['input']>;
};

export type MemberCaregiverFilterInputType = {
  /** `Email` subfield */
  email?: InputMaybe<MemberCaregiverEmailFilterInputType>;
  /** `FirstName` subfield */
  firstName?: InputMaybe<MemberCaregiverFirstNameFilterInputType>;
  /** `LastName` subfield */
  lastName?: InputMaybe<MemberCaregiverLastNameFilterInputType>;
  /** `PhoneNumber` subfield */
  phoneNumber?: InputMaybe<MemberCaregiverPhoneNumberFilterInputType>;
};

export type MemberCaregiverFirstNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Icontains` lookup */
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type MemberCaregiverLastNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Icontains` lookup */
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type MemberCaregiverPhoneNumberFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Startswith` lookup */
  startswith?: InputMaybe<Scalars['String']['input']>;
};

export type MemberClinicianEmailFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Startswith` lookup */
  startswith?: InputMaybe<Scalars['String']['input']>;
};

export type MemberClinicianFilterInputType = {
  /** `Email` subfield */
  email?: InputMaybe<MemberClinicianEmailFilterInputType>;
  /** `FirstName` subfield */
  firstName?: InputMaybe<MemberClinicianFirstNameFilterInputType>;
  /** `Id` subfield */
  id?: InputMaybe<MemberClinicianIdFilterInputType>;
  /** `LastName` subfield */
  lastName?: InputMaybe<MemberClinicianLastNameFilterInputType>;
};

export type MemberClinicianFirstNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Icontains` lookup */
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type MemberClinicianIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type MemberClinicianLastNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Icontains` lookup */
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type MemberCreateMightierAccountMutation = {
  member: Maybe<MemberNode>;
};

export type MemberDateOfBirthFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Date']['input']>;
};

export type MemberFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<MemberFilterInputType>>>;
  /** `Billingprofile` field */
  billingprofile?: InputMaybe<MemberBillingprofileFilterInputType>;
  /** `Caregiver` field */
  caregiver?: InputMaybe<MemberCaregiverFilterInputType>;
  /** `Clinician` field */
  clinician?: InputMaybe<MemberClinicianFilterInputType>;
  /** `DateOfBirth` field */
  dateOfBirth?: InputMaybe<MemberDateOfBirthFilterInputType>;
  /** `FirstName` field */
  firstName?: InputMaybe<MemberFirstNameFilterInputType>;
  /** `IsHidden` field */
  isHidden?: InputMaybe<MemberIsHiddenFilterInputType>;
  /** `LastName` field */
  lastName?: InputMaybe<MemberLastNameFilterInputType>;
  /** `MemberSubscriptionOrderCount` field */
  memberSubscriptionOrderCount?: InputMaybe<MemberMemberSubscriptionOrderCountFilterInputType>;
  /** `Membermightiermetadata` field */
  membermightiermetadata?: InputMaybe<MemberMembermightiermetadataFilterInputType>;
  /** `Memberstatuslookup` field */
  memberstatuslookup?: InputMaybe<MemberMemberstatuslookupFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<MemberFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<MemberFilterInputType>>>;
  /** `Reviewhold` field */
  reviewhold?: InputMaybe<MemberReviewholdFilterInputType>;
};

export type MemberFirstNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Icontains` lookup */
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type MemberIntakeSubmissionFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<MemberIntakeSubmissionFilterInputType>>>;
  /** `Member` field */
  member?: InputMaybe<MemberIntakeSubmissionMemberFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<MemberIntakeSubmissionFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<MemberIntakeSubmissionFilterInputType>>>;
  /** `SubmittedAt` field */
  submittedAt?: InputMaybe<MemberIntakeSubmissionSubmittedAtFilterInputType>;
};

export type MemberIntakeSubmissionMemberFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type MemberIntakeSubmissionNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  member: Maybe<MemberNode>;
  submissionJson: Scalars['JSONString']['output'];
  submittedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MemberIntakeSubmissionNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MemberIntakeSubmissionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MemberIntakeSubmissionNode` and its cursor. */
export type MemberIntakeSubmissionNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<MemberIntakeSubmissionNode>;
};

export type MemberIntakeSubmissionSubmittedAtFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MemberIsHiddenFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberLastNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** `Icontains` lookup */
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type MemberMemberSubscriptionOrderCountFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Decimal']['input']>;
};

export type MemberMembermightiermetadataExternalAccountIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type MemberMembermightiermetadataExternalPlayerIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type MemberMembermightiermetadataFilterInputType = {
  /** `ExternalAccountId` subfield */
  externalAccountId?: InputMaybe<MemberMembermightiermetadataExternalAccountIdFilterInputType>;
  /** `ExternalPlayerId` subfield */
  externalPlayerId?: InputMaybe<MemberMembermightiermetadataExternalPlayerIdFilterInputType>;
  /** `Isnull` lookup */
  isnull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberMemberstatuslookupFilterInputType = {
  /** `LatestBillingEligibilityCheck` subfield */
  latestBillingEligibilityCheck?: InputMaybe<MemberMemberstatuslookupLatestBillingEligibilityCheckFilterInputType>;
  /** `LatestClinicalEligibilityCheck` subfield */
  latestClinicalEligibilityCheck?: InputMaybe<MemberMemberstatuslookupLatestClinicalEligibilityCheckFilterInputType>;
};

export type MemberMemberstatuslookupLatestBillingEligibilityCheckFilterInputType = {
  /** `IsEligible` subfield */
  isEligible?: InputMaybe<MemberMemberstatuslookupLatestBillingEligibilityCheckIsEligibleFilterInputType>;
  /** `Isnull` lookup */
  isnull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberMemberstatuslookupLatestBillingEligibilityCheckIsEligibleFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberMemberstatuslookupLatestClinicalEligibilityCheckFilterInputType = {
  /** `IsEligible` subfield */
  isEligible?: InputMaybe<MemberMemberstatuslookupLatestClinicalEligibilityCheckIsEligibleFilterInputType>;
  /** `Isnull` lookup */
  isnull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberMemberstatuslookupLatestClinicalEligibilityCheckIsEligibleFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberMightierMetadataNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  externalAccountId: Scalars['String']['output'];
  externalPlayerId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  member: Maybe<MemberNode>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MemberNode = Node & {
  /** @deprecated Unused and returns stub data. */
  accountStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use .memberstatuslookup.latestBillingEligibilityCheck instead. */
  billingEligibilityStatus: Maybe<Scalars['String']['output']>;
  billingeligibilitycheckSet: BillingEligibilityCheckNodeConnection;
  billingprofile: Maybe<BillingProfileNode>;
  caregiver: Maybe<CaregiverNode>;
  caregiverRelationshipToMember: Scalars['String']['output'];
  /** @deprecated Use .memberstatuslookup.latestClinicalEligibilityCheck instead. */
  clinicalEligibilityStatus: Maybe<Scalars['String']['output']>;
  clinicaleligibilitycheckSet: ClinicalEligibilityCheckNodeConnection;
  clinician: Maybe<UserNode>;
  createdAt: Scalars['DateTime']['output'];
  datareviewcheckSet: DataReviewCheckNodeConnection;
  dateOfBirth: Scalars['Date']['output'];
  djangoPk: Scalars['Int']['output'];
  ethnicity: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Hidden members are excluded by default in user-facing views. */
  isHidden: Scalars['Boolean']['output'];
  isHomeInternetReliable: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  latestDataReviewDate: Maybe<Scalars['DateTime']['output']>;
  memberintakesubmission: Maybe<MemberIntakeSubmissionNode>;
  membermightiermetadata: Maybe<MemberMightierMetadataNode>;
  memberstatuslookup: Maybe<MemberStatusLookupNode>;
  membersubscriptionorderSet: MemberSubscriptionOrderNodeConnection;
  offlineLoginCode: Maybe<Scalars['String']['output']>;
  race: Maybe<Scalars['String']['output']>;
  /** @deprecated Legacy field is innapropriately named. Use caregiver_relationship_to_member instead. */
  relationshipToCaregiver: Maybe<Scalars['String']['output']>;
  reviewholdSet: ReviewHoldNodeConnection;
  updatedAt: Scalars['DateTime']['output'];
};


export type MemberNodeBillingeligibilitycheckSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  completedBy: InputMaybe<Scalars['ID']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  isEligible: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  member: InputMaybe<Scalars['ID']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type MemberNodeClinicaleligibilitycheckSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  completedBy: InputMaybe<Scalars['ID']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  isEligible: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  member: InputMaybe<Scalars['ID']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type MemberNodeDatareviewcheckSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  completedBy: InputMaybe<Scalars['ID']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  member: InputMaybe<Scalars['ID']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type MemberNodeMembersubscriptionorderSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  externalId: InputMaybe<Scalars['String']['input']>;
  externalOrderProviderId: InputMaybe<Scalars['ID']['input']>;
  externalOrderProvider_Slug: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  memberId: InputMaybe<Scalars['ID']['input']>;
  member_Caregiver_Email_Iexact: InputMaybe<Scalars['String']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type MemberNodeReviewholdSetArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  completedBy: InputMaybe<Scalars['ID']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  isOpen: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  member: InputMaybe<Scalars['ID']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};

export type MemberNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MemberNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MemberNode` and its cursor. */
export type MemberNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<MemberNode>;
};

export type MemberReviewholdFilterInputType = {
  /** `IsOpen` subfield */
  isOpen?: InputMaybe<MemberReviewholdIsOpenFilterInputType>;
};

export type MemberReviewholdIsOpenFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberStatusLookupNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  latestBillingEligibilityCheck: Maybe<BillingEligibilityCheckNode>;
  latestClinicalEligibilityCheck: Maybe<ClinicalEligibilityCheckNode>;
  latestDataReviewCheck: Maybe<DataReviewCheckNode>;
  member: Maybe<MemberNode>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MemberSubscriptionOrderCreateMutation = {
  memberSubscriptionOrder: Maybe<MemberSubscriptionOrderNode>;
};

export type MemberSubscriptionOrderExternalIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type MemberSubscriptionOrderExternalOrderProviderFilterInputType = {
  /** `Slug` subfield */
  slug?: InputMaybe<MemberSubscriptionOrderExternalOrderProviderSlugFilterInputType>;
};

export type MemberSubscriptionOrderExternalOrderProviderIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type MemberSubscriptionOrderExternalOrderProviderSlugFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type MemberSubscriptionOrderFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<MemberSubscriptionOrderFilterInputType>>>;
  /** `ExternalId` field */
  externalId?: InputMaybe<MemberSubscriptionOrderExternalIdFilterInputType>;
  /** `ExternalOrderProvider` field */
  externalOrderProvider?: InputMaybe<MemberSubscriptionOrderExternalOrderProviderFilterInputType>;
  /** `ExternalOrderProviderId` field */
  externalOrderProviderId?: InputMaybe<MemberSubscriptionOrderExternalOrderProviderIdFilterInputType>;
  /** `Member` field */
  member?: InputMaybe<MemberSubscriptionOrderMemberFilterInputType>;
  /** `MemberId` field */
  memberId?: InputMaybe<MemberSubscriptionOrderMemberIdFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<MemberSubscriptionOrderFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<MemberSubscriptionOrderFilterInputType>>>;
};

export type MemberSubscriptionOrderMemberCaregiverEmailFilterInputType = {
  /** `Iexact` lookup */
  iexact?: InputMaybe<Scalars['String']['input']>;
};

export type MemberSubscriptionOrderMemberCaregiverFilterInputType = {
  /** `Email` subfield */
  email?: InputMaybe<MemberSubscriptionOrderMemberCaregiverEmailFilterInputType>;
};

export type MemberSubscriptionOrderMemberFilterInputType = {
  /** `Caregiver` subfield */
  caregiver?: InputMaybe<MemberSubscriptionOrderMemberCaregiverFilterInputType>;
};

export type MemberSubscriptionOrderMemberIdFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type MemberSubscriptionOrderNode = Node & {
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
  externalOrderProvider: Maybe<ExternalOrderProviderNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  member: Maybe<MemberNode>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MemberSubscriptionOrderNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MemberSubscriptionOrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MemberSubscriptionOrderNode` and its cursor. */
export type MemberSubscriptionOrderNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<MemberSubscriptionOrderNode>;
};

export type MemberUpdateMutation = {
  member: Maybe<MemberNode>;
};

export type Mutation = {
  addressCreate: Maybe<AddressCreateMutation>;
  addressUpdate: Maybe<AddressUpdateMutation>;
  billingEligibilityCheckCreate: Maybe<BillingEligibilityCheckCreateMutation>;
  billingEligibilityCheckUpdate: Maybe<BillingEligibilityCheckUpdateMutation>;
  billingProfileUpdate: Maybe<BillingProfileUpdateMutation>;
  caregiverCreateShopifyOrder: Maybe<CaregiverCreateShopifyOrderMutation>;
  caregiverUpdate: Maybe<CaregiverUpdateMutation>;
  clinicalEligibilityCheckCreate: Maybe<ClinicalEligibilityCheckCreateMutation>;
  clinicalEligibilityCheckUpdate: Maybe<ClinicalEligibilityCheckUpdateMutation>;
  dataReviewCheckCreate: Maybe<DataReviewCheckCreateMutation>;
  dataReviewCheckUpdate: Maybe<DataReviewCheckUpdateMutation>;
  externalOrderProviderCreate: Maybe<ExternalOrderProviderCreateMutation>;
  intakeFormSubmit: Maybe<IntakeSubmitMutation>;
  memberCreateMightierAccount: Maybe<MemberCreateMightierAccountMutation>;
  memberSubscriptionOrderCreate: Maybe<MemberSubscriptionOrderCreateMutation>;
  memberUpdate: Maybe<MemberUpdateMutation>;
  phiFileReferenceCreate: Maybe<PhiFileReferenceCreateMutation>;
  reviewHoldCreate: Maybe<ReviewHoldCreateMutation>;
  reviewHoldUpdate: Maybe<ReviewHoldUpdateMutation>;
};


export type MutationAddressCreateArgs = {
  input: CreateAddressInput;
};


export type MutationAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchAddressInput;
};


export type MutationBillingEligibilityCheckCreateArgs = {
  input: CreateBillingEligibilityCheckInput;
};


export type MutationBillingEligibilityCheckUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchBillingEligibilityCheckInput;
};


export type MutationBillingProfileUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchBillingProfileInput;
};


export type MutationCaregiverCreateShopifyOrderArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCaregiverUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchCaregiverInput;
};


export type MutationClinicalEligibilityCheckCreateArgs = {
  input: CreateClinicalEligibilityCheckInput;
};


export type MutationClinicalEligibilityCheckUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchClinicalEligibilityCheckInput;
};


export type MutationDataReviewCheckCreateArgs = {
  input: CreateDataReviewCheckInput;
};


export type MutationDataReviewCheckUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchDataReviewCheckInput;
};


export type MutationExternalOrderProviderCreateArgs = {
  input: CreateExternalOrderProviderInput;
};


export type MutationIntakeFormSubmitArgs = {
  input: IntakeSubmitInputType;
};


export type MutationMemberCreateMightierAccountArgs = {
  graphqlId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMemberSubscriptionOrderCreateArgs = {
  input: CreateMemberSubscriptionOrderInput;
};


export type MutationMemberUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchMemberInput;
};


export type MutationPhiFileReferenceCreateArgs = {
  input: CreatePhiFileReferenceInput;
};


export type MutationReviewHoldCreateArgs = {
  input: CreateReviewHoldInput;
};


export type MutationReviewHoldUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PatchReviewHoldInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PatchAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type PatchBillingEligibilityCheckInput = {
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PatchBillingProfileInput = {
  /** The identification number of the Member in their insurance provider's system. */
  externalMemberId?: InputMaybe<Scalars['String']['input']>;
  insuranceProvider?: InputMaybe<Scalars['ID']['input']>;
};

export type PatchCaregiverInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PatchClinicalEligibilityCheckInput = {
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PatchDataReviewCheckInput = {
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PatchMemberInput = {
  caregiverRelationshipToMember?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isHomeInternetReliable?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
};

export type PatchReviewHoldInput = {
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PhiFileReferenceClaimType = {
  claimCode: Scalars['UUID']['input'];
  id: Scalars['ID']['input'];
};

export type PhiFileReferenceCreateMutation = {
  phiFileReference: Maybe<PhiFileReferenceNode>;
  s3UploadInfo: Maybe<S3ObjectInfoType>;
};

export type PhiFileReferenceFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<PhiFileReferenceFilterInputType>>>;
  /** `Not` field */
  not?: InputMaybe<PhiFileReferenceFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<PhiFileReferenceFilterInputType>>>;
  /** `S3BucketName` field */
  s3BucketName?: InputMaybe<PhiFileReferenceS3BucketNameFilterInputType>;
  /** `S3Key` field */
  s3Key?: InputMaybe<PhiFileReferenceS3KeyFilterInputType>;
};

export type PhiFileReferenceNode = Node & {
  billingProfile: Maybe<BillingProfileNode>;
  /** An un-editable, auto-generated value used to ensure that only those who create a PhiFileReference can claim it during intake. */
  claimCode: Scalars['UUID']['output'];
  contentType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Files may be uploaded during intake, but may never be associated with a member, for example if intake was never completed. We must store some info so that any orphaned records may be identified. */
  identifyingInfo: Scalars['String']['output'];
  s3BucketName: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PhiFileReferenceNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PhiFileReferenceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PhiFileReferenceNode` and its cursor. */
export type PhiFileReferenceNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PhiFileReferenceNode>;
};

export type PhiFileReferenceS3BucketNameFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

export type PhiFileReferenceS3KeyFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['String']['input']>;
};

/**
 * NOTE:
 *
 * Not exposed as a specific query - graphene-django simply parsing this class means that policyholder can be
 * accessed via BillingProfile node.
 *
 * There's no reason to expose this node anywhere EXCEPT within BillingProfile node
 */
export type PolicyHolderNode = Node & {
  billingProfile: Maybe<BillingProfileNode>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth: Scalars['Date']['output'];
  djangoPk: Scalars['Int']['output'];
  externalSubscriberNumber: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groupNumber: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Query = {
  address: Maybe<AddressNode>;
  allAddresses: Maybe<AddressNodeConnection>;
  allBillingEligibilityChecks: Maybe<BillingEligibilityCheckNodeConnection>;
  allBillingProfiles: Maybe<BillingProfileNodeConnection>;
  allCaregivers: Maybe<CaregiverNodeConnection>;
  allClinicalEligibilityChecks: Maybe<ClinicalEligibilityCheckNodeConnection>;
  allExternalOrderProviders: Maybe<ExternalOrderProviderNodeConnection>;
  allInsuranceProviders: Maybe<InsuranceProviderNodeConnection>;
  allMemberIntakeSubmissions: Maybe<MemberIntakeSubmissionNodeConnection>;
  allMemberSubscriptionOrders: Maybe<MemberSubscriptionOrderNodeConnection>;
  allMembers: Maybe<MemberNodeConnection>;
  allPhiFileReferences: Maybe<PhiFileReferenceNodeConnection>;
  allReviewHolds: Maybe<ReviewHoldNodeConnection>;
  billingEligibilityCheck: Maybe<BillingEligibilityCheckNode>;
  billingProfile: Maybe<BillingProfileNode>;
  caregiver: Maybe<CaregiverNode>;
  clinicalEligibilityCheck: Maybe<ClinicalEligibilityCheckNode>;
  dataReviewCheck: Maybe<DataReviewCheckNode>;
  dataReviewChecks: Maybe<DataReviewCheckNodeConnection>;
  externalOrderProvider: Maybe<ExternalOrderProviderNode>;
  insuranceProvider: Maybe<InsuranceProviderNode>;
  member: Maybe<MemberNode>;
  memberIntakeSubmission: Maybe<MemberIntakeSubmissionNode>;
  memberSubscriptionOrder: Maybe<MemberSubscriptionOrderNode>;
  phiFileReference: Maybe<PhiFileReferenceNode>;
  reviewHold: Maybe<ReviewHoldNode>;
  user: Maybe<UserNode>;
  userInfo: Maybe<UserNode>;
};


export type QueryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAllAddressesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<AddressFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllBillingEligibilityChecksArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<BillingEligibilityCheckFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllBillingProfilesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<BillingProfileFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllCaregiversArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<CaregiverFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllClinicalEligibilityChecksArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<ClinicalEligibilityCheckFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllExternalOrderProvidersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<ExternalOrderProviderFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllInsuranceProvidersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<InsuranceProviderFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMemberIntakeSubmissionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<MemberIntakeSubmissionFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMemberSubscriptionOrdersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<MemberSubscriptionOrderFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMembersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<MemberFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllPhiFileReferencesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<PhiFileReferenceFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllReviewHoldsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<ReviewHoldFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingEligibilityCheckArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillingProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCaregiverArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicalEligibilityCheckArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataReviewCheckArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataReviewChecksArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<DataReviewCheckFilterInputType>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternalOrderProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsuranceProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMemberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMemberIntakeSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMemberSubscriptionOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPhiFileReferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewHoldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type ReviewHoldCompletedByFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewHoldCreateMutation = {
  reviewHold: Maybe<ReviewHoldNode>;
};

export type ReviewHoldFilterInputType = {
  /** `And` field */
  and?: InputMaybe<Array<InputMaybe<ReviewHoldFilterInputType>>>;
  /** `CompletedBy` field */
  completedBy?: InputMaybe<ReviewHoldCompletedByFilterInputType>;
  /** `IsOpen` field */
  isOpen?: InputMaybe<ReviewHoldIsOpenFilterInputType>;
  /** `Member` field */
  member?: InputMaybe<ReviewHoldMemberFilterInputType>;
  /** `Not` field */
  not?: InputMaybe<ReviewHoldFilterInputType>;
  /** `Or` field */
  or?: InputMaybe<Array<InputMaybe<ReviewHoldFilterInputType>>>;
};

export type ReviewHoldIsOpenFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewHoldMemberFilterInputType = {
  /** `Exact` lookup */
  exact?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewHoldNode = Node & {
  completedBy: Maybe<UserNode>;
  createdAt: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  member: Maybe<MemberNode>;
  note: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ReviewHoldNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReviewHoldNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReviewHoldNode` and its cursor. */
export type ReviewHoldNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ReviewHoldNode>;
};

export type ReviewHoldUpdateMutation = {
  reviewHold: Maybe<ReviewHoldNode>;
};

export type S3ObjectInfoType = {
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  uploadUrl: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderType = {
  createdAt: Maybe<Scalars['String']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  orderId: Maybe<Scalars['String']['output']>;
  totalPrice: Maybe<Scalars['Float']['output']>;
};

export type StaffProfileNode = Node & {
  djangoPk: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  licensedStates: Array<Scalars['String']['output']>;
};

export type UserNode = Node & {
  dateJoined: Scalars['DateTime']['output'];
  djangoPk: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  permissions: Maybe<Array<Scalars['String']['output']>>;
  staffProfile: Maybe<StaffProfileNode>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
};

export type ListInsuranceProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInsuranceProvidersQuery = { allInsuranceProviders: { edges: Array<{ node: { id: string, slug: string, niceName: string, mcsPartner: { slug: string, niceName: string } | null } | null } | null> } | null };

export type SubmitIntakeFormMutationVariables = Exact<{
  input: IntakeSubmitInputType;
}>;


export type SubmitIntakeFormMutation = { intakeFormSubmit: { graphqlMemberId: string | null } | null };

export type CreatePhiFileReferenceMutationVariables = Exact<{
  input: CreatePhiFileReferenceInput;
}>;


export type CreatePhiFileReferenceMutation = { phiFileReferenceCreate: { phiFileReference: { id: string, claimCode: string } | null, s3UploadInfo: { uploadUrl: string | null } | null } | null };


export const ListInsuranceProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListInsuranceProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allInsuranceProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"niceName"}},{"kind":"Field","name":{"kind":"Name","value":"mcsPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"niceName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListInsuranceProvidersQuery, ListInsuranceProvidersQueryVariables>;
export const SubmitIntakeFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitIntakeForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntakeSubmitInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intakeFormSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"graphqlMemberId"}}]}}]}}]} as unknown as DocumentNode<SubmitIntakeFormMutation, SubmitIntakeFormMutationVariables>;
export const CreatePhiFileReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePhiFileReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePhiFileReferenceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phiFileReferenceCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phiFileReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"claimCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"s3UploadInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePhiFileReferenceMutation, CreatePhiFileReferenceMutationVariables>;